import { defineSlotRecipe } from '@chakra-ui/react';
export const barSegmentRecipe = defineSlotRecipe({
    className: 'bar-segment',
    slots: ['root', 'segment'],
    base: {
        // Rounded outer corners come from the container; segments are flush
        // (no gap) and square so the intersection between two segments has no
        // radius. overflow:hidden clips the outer segment corners to the radius.
        root: {
            display: 'flex',
            width: '100%',
            rounded: 'l1',
            overflow: 'hidden',
        },
        segment: {
            transition: 'all 0.3s ease',
        },
    },
    variants: {
        size: {
            sm: {
                segment: { height: '12px' },
            },
            md: {
                segment: { height: '20px' },
            },
        },
    },
    defaultVariants: {
        size: 'md',
    },
});
